import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["list", "prev", "next"];

  connect() {
    this.current_position = 0;
    this.startX = 0;

    if (this.hasListTarget) {
      this.listTarget.addEventListener(
        "touchstart",
        this.onTouchStart.bind(this),
      );
      this.listTarget.addEventListener("touchend", this.onTouchEnd.bind(this));
    }
  }

  onTouchStart(event) {
    console.log("touch start");
    this.startX = event.touches[0].clientX;
  }

  onTouchEnd(event) {
    const endX = event.changedTouches[0].clientX;
    const diffX = endX - this.startX;
    if (Math.abs(diffX) > 50) {
      // threshold for swipe
      if (diffX < 0) {
        this.next();
      } else {
        this.prev();
      }
    }
  }

  prev() {
    this.current_position -= 1;
    this.handlePositionUpdate();
  }

  next() {
    this.current_position += 1;
    this.handlePositionUpdate();
  }

  handlePositionUpdate() {
    const clientWidth = this.listTarget.clientWidth;
    const scrollWidth = this.listTarget.scrollWidth;

    const maxPosition = Math.floor(scrollWidth / clientWidth);

    if (this.current_position >= maxPosition || scrollWidth == clientWidth) {
      this.current_position = maxPosition;
    }
    if (this.current_position <= 0) {
      this.current_position = 0;
    }
    // Scroll the list instead of using transform
    this.listTarget.scrollTo({
      left: this.current_position * clientWidth,
      behavior: "smooth",
    });
  }
}
